import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AmenityhotelService from "../../services/amenityhotel.service";

/* =================== Thunks =================== */

export const getuserAmenity = createAsyncThunk(
  "amenity/getAmenity",
  async (params, thunkAPI) => {
    try {
      const response = await AmenityhotelService.getuserAmenity(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addAmenity = createAsyncThunk(
  "amenity/addAmenity",
  async (data, thunkAPI) => {
    try {
      const response = await AmenityhotelService.addAmenity(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const updateAmenity = createAsyncThunk(
  "amenity/updateAmenity",
  async (payload, thunkAPI) => {
    try {
      const response = await AmenityhotelService.editAmenity(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const deleteAmenity = createAsyncThunk(
  "amenity/deleteAmenity",
  async (id, thunkAPI) => {
    try {
      await AmenityhotelService.deleteAmenity(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* =================== State =================== */

const initialState = {
  loading: false,
  error: null,
  amenitylist: [],
  updateSuccess: false,
};

/* =================== Slice =================== */

const amenitySlice = createSlice({
  name: "amenity",
  initialState,
  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder

      /* ---------- Get ---------- */
      .addCase(getuserAmenity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getuserAmenity.fulfilled, (state, action) => {
        state.loading = false;
        state.amenitylist = action.payload?.amenityData || [];
      })
      .addCase(getuserAmenity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Add ---------- */
      .addCase(addAmenity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addAmenity.fulfilled, (state, action) => {
        state.loading = false;

        const newAmenity =
          action.payload?.data ||
          action.payload?.amenityData ||
          action.payload;

        if (newAmenity) {
          state.amenitylist.unshift(newAmenity);
        }
      })
      .addCase(addAmenity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Update ---------- */
      .addCase(updateAmenity.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(updateAmenity.fulfilled, (state, action) => {
        state.loading = false;
        state.updateSuccess = true;

        const updated =
          action.payload?.data || action.payload?.amenityData;

        if (updated?._id) {
          const index = state.amenitylist.findIndex(
            (item) => item._id === updated._id
          );
          if (index !== -1) {
            state.amenitylist[index] = updated;
          }
        }
      })
      .addCase(updateAmenity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Delete ---------- */
      .addCase(deleteAmenity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAmenity.fulfilled, (state, action) => {
        state.loading = false;
        state.amenitylist = state.amenitylist.filter(
          (item) => item._id !== action.payload
        );
      })
      .addCase(deleteAmenity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateStatus } = amenitySlice.actions;
export default amenitySlice.reducer;
